import { Skeleton } from "@mui/material";
import React from "react";

/* eslint-disable no-unneeded-ternary */

interface SkeletonIndicatorProps {
  width?: number | string;
  height?: number | string;
  variant?: "text" | "rectangular" | "rounded" | "circular";
  className?: string;
  loading?: Boolean;
  error?: Error;
}

/**
 * Indicate the loading/error status
 * (e.g., for a network fetchData call).
 */
export function SkeletonIndicator(props: SkeletonIndicatorProps) {
  const { width, height, variant, className, loading, error } = props;
  let status;
  if (loading || error) {
    status = (
      <Skeleton
        role="progressbar"
        variant={variant || "rounded"}
        width={width}
        height={height}
        className={className}
        animation="wave"
      />
    );
  }
  return status || null;
}
